import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({ name: "FinalizedCombiBoolean" })
export class FinalizedCombiBoolean implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: boolean): string {
    return this.translateService.instant(value ? "SHARED.YES" : "SHARED.NO");
  }
}
